import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { MdSearchOff, MdBusiness, MdSearch } from "react-icons/md";

import styles from "./Cluster.module.scss";
import { useCluster } from "./useCluster";
import { clusterRoute } from "../../common/utils/constants";
import { PageHeader } from "../../common/components/pageHeader/PageHeader";
import { Search } from "../../common/components/search/Search";
import { useSearch } from "../../common/components/search/useSearch";
import { EmptyState } from "../../common/components/emptyState/EmptyState";

export const Cluster: React.FC = () => {
  const { query, setQuery, clearSearch, isDebouncing } = useSearch();
  const { items, count, ready, isFetching } = useCluster();

  if (!ready) return null;

  const isBusy = isFetching || isDebouncing;

  return (
    <div className={styles.Page}>
      <Helmet>
        <title>Компании — logmall</title>
        <meta name="description" content="Компании, которые ищут сотрудников" />
      </Helmet>

      <PageHeader title="Компании" subtitle={`${count} компаний`} />

      <div className={styles.SearchWrap}>
        <Search
          value={query}
          onChange={setQuery}
          clear={clearSearch}
          placeHolder="Поиск по названию компании..."
        />
      </div>

      {items.length === 0 && !isBusy ? (
        query.trim() ? (
          <EmptyState
            icon={MdSearchOff}
            title="Ничего не найдено"
            description={`По запросу «${query}» нет ни одной компании.`}
          />
        ) : (
          <EmptyState
            icon={MdSearch}
            title="Введите запрос"
            description="Начните вводить название компании, чтобы найти нужную."
          />
        )
      ) : items.length === 0 && isBusy ? (
        <div style={{ minHeight: 400 }} />
      ) : (
        <div className={styles.Grid}>
          {items.map((c) => (
            <Link key={c.id} to={clusterRoute(c.id)} className={styles.Card}>
              <img
                src={`https://${c.domain}/icons/logo512.png`}
                alt={c.name}
                className={styles.Logo}
                loading="lazy"
              />
              <div className={styles.TextInfo}>
                <h3 className={styles.Name}>{c.name}</h3>
                {c.description && (
                  <p className={styles.Description}>{c.description}</p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};